import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class TherapyInsurer extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  thirdpartyPriceTimeState: this.props.therapyInsurer,
                  selectedTherapyInsurer: {
                        value: this.props.therapyInsurer.therapy_price_baseinsurer_therapy_price_id,
                        label: this.props.therapyInsurer.therapy_baseinsurer_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionTherapyInsurer: [],
            }
      }
      componentDidMount() {
            this.getoptionTherapyInsurer()
      }

      getoptionTherapyInsurer = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].therapy_baseinsurer_id, label: arr.data[k].therapy_baseinsurer_name })
                              }
                              self.setState({ optionTherapyInsurer: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_therapy_baseinsurer")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedTherapyInsurer) => {
            var temparray = this.state.thirdpartyPriceTimeState
            temparray.therapy_price_baseinsurer_therapy_price_id = selectedTherapyInsurer.value
            this.setState({ selectedTherapyInsurer: selectedTherapyInsurer, thirdpartyPriceTimeState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.thirdpartyPriceTimeState
            temparray.therapy_price_baseinsurer_percent = event
            this.setState({ thirdpartyPriceTimeState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { thirdpartyPriceTimeState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_baseinsurer")
            fd.append("therapy_price_baseinsurer_id", thirdpartyPriceTimeState.therapy_price_baseinsurer_id)
            fd.append("therapy_price_baseinsurer_percent", thirdpartyPriceTimeState.therapy_price_baseinsurer_percent)

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { thirdpartyPriceTimeState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_baseinsurer")
            fd.append("therapy_price_baseinsurer_id", thirdpartyPriceTimeState.therapy_price_baseinsurer_id)

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionTherapyInsurer, snackMode, snackstr, showSnack, visible, selectedTherapyInsurer, thirdpartyPriceTimeState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on">بیمه گر پایه </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"بیمه گر پایه"}
                                                value={selectedTherapyInsurer}
                                                onChange={this.handleInstalmentMode}
                                                options={optionTherapyInsurer}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="  درصد اضافه نرخ "
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={thirdpartyPriceTimeState.therapy_price_baseinsurer_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(TherapyInsurer)
